"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = exports.ICON_SIZE = exports.ICON_NAME = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var Icons = _interopRequireWildcard(require("b2b-components/theme/components/Icon/Icons"));
var _isDefined = require("b2b-components/utils/isDefined");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Icon.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let ICON_SIZE = exports.ICON_SIZE = /*#__PURE__*/function (ICON_SIZE) {
  ICON_SIZE["default"] = "default";
  ICON_SIZE["large"] = "large";
  ICON_SIZE["semilarge"] = "semilarge";
  ICON_SIZE["medium"] = "medium";
  ICON_SIZE["small"] = "small";
  ICON_SIZE["xsmall"] = "xsmall";
  ICON_SIZE["mediumplus"] = "mediumplus";
  return ICON_SIZE;
}({});
let ICON_NAME = exports.ICON_NAME = /*#__PURE__*/function (ICON_NAME) {
  ICON_NAME["account"] = "IconAccount";
  ICON_NAME["alertError"] = "IconAlertError";
  ICON_NAME["alertInfo"] = "IconAlertInfo";
  ICON_NAME["alertNotification"] = "IconAlertNotification";
  ICON_NAME["alertSuccess"] = "IconAlertSuccess";
  ICON_NAME["alertWarning"] = "IconAlertWarning";
  ICON_NAME["arrowDown"] = "IconArrowDown";
  ICON_NAME["arrowLeft"] = "IconArrowLeft";
  ICON_NAME["arrowRight"] = "IconArrowRight";
  ICON_NAME["arrowUp"] = "IconArrowUp";
  ICON_NAME["balance"] = "IconBalance";
  ICON_NAME["boxCheck"] = "IconBoxCheck";
  ICON_NAME["cart"] = "IconCart";
  ICON_NAME["cartOutline"] = "IconCartOutline";
  ICON_NAME["certificate"] = "IconCertificate";
  ICON_NAME["checkmark"] = "IconCheckmark";
  ICON_NAME["checkmarkMixed"] = "IconCheckmarkMixed";
  ICON_NAME["clock"] = "IconClock";
  ICON_NAME["close"] = "IconClose";
  ICON_NAME["codeScanner"] = "IconCodeScanner";
  ICON_NAME["compare"] = "IconCompare";
  ICON_NAME["cookie"] = "IconCookie";
  ICON_NAME["copy"] = "IconCopy";
  ICON_NAME["coreAssortment"] = "IconCoreAssortment";
  ICON_NAME["costCenter"] = "IconCostCenter";
  ICON_NAME["dashboard"] = "IconDashboard";
  ICON_NAME["delivery"] = "IconDelivery";
  ICON_NAME["deliveryClockOutline"] = "IconDeliveryClockOutline";
  ICON_NAME["discount"] = "IconDiscount";
  ICON_NAME["dots"] = "IconDots";
  ICON_NAME["download"] = "IconDownload";
  ICON_NAME["edit"] = "IconEdit";
  ICON_NAME["emailSend"] = "IconEmailSend";
  ICON_NAME["expressOrder"] = "IconExpressOrder";
  ICON_NAME["eyeHide"] = "IconEyeHide";
  ICON_NAME["eyeShow"] = "IconEyeShow";
  ICON_NAME["favorite"] = "IconFavorite";
  ICON_NAME["filter"] = "IconFilter";
  ICON_NAME["fullscreen"] = "IconFullscreen";
  ICON_NAME["fullscreenClose"] = "IconFullscreenClose";
  ICON_NAME["globe"] = "IconGlobe";
  ICON_NAME["house"] = "IconHouse";
  ICON_NAME["infoOutline"] = "IconInfoOutline";
  ICON_NAME["invoice"] = "IconInvoice";
  ICON_NAME["linkExternal"] = "IconLinkExternal";
  ICON_NAME["loader"] = "IconLoader";
  ICON_NAME["location"] = "IconLocation";
  ICON_NAME["lock"] = "IconLock";
  ICON_NAME["mail"] = "IconMail";
  ICON_NAME["menu"] = "IconMenu";
  ICON_NAME["minus"] = "IconMinus";
  ICON_NAME["newsletter"] = "IconNewsletter";
  ICON_NAME["parcelArrowOutline"] = "IconParcelArrowOutline";
  ICON_NAME["packagePlusOutline"] = "IconPackagePlusOutline";
  ICON_NAME["bulk"] = "IconBulkPrice";
  ICON_NAME["pdf"] = "IconPdf";
  ICON_NAME["pdfFile"] = "IconPdfFile";
  ICON_NAME["phone"] = "IconPhone";
  ICON_NAME["plus"] = "IconPlus";
  ICON_NAME["printAndPromo"] = "IconPrintAndPromo";
  ICON_NAME["printer"] = "IconPrinter";
  ICON_NAME["progressDone"] = "IconProgressDone";
  ICON_NAME["progressOngoing"] = "IconProgressOngoing";
  ICON_NAME["quickview"] = "IconQuickview";
  ICON_NAME["rangeEu"] = "IconRangeEu";
  ICON_NAME["refresh"] = "IconRefresh";
  ICON_NAME["remove"] = "IconRemove";
  ICON_NAME["repair"] = "IconRepair";
  ICON_NAME["reportError"] = "IconReportError";
  ICON_NAME["request"] = "IconRequest";
  ICON_NAME["return"] = "IconReturn";
  ICON_NAME["rmaSolid"] = "IconRmaSolid";
  ICON_NAME["rotate"] = "IconRotate";
  ICON_NAME["rotate360"] = "IconRotate360";
  ICON_NAME["search"] = "IconSearch";
  ICON_NAME["share"] = "IconShare";
  ICON_NAME["socialFacebook"] = "IconSocialFacebook";
  ICON_NAME["socialLinkedin"] = "IconSocialLinkedin";
  ICON_NAME["socialTwitter"] = "IconSocialTwitter";
  ICON_NAME["socialYoutube"] = "IconSocialYoutube";
  ICON_NAME["toplink"] = "IconToplink";
  ICON_NAME["user"] = "IconUser";
  ICON_NAME["userGroup"] = "IconUserGroup";
  ICON_NAME["video"] = "IconVideo";
  ICON_NAME["viewList"] = "IconViewList";
  ICON_NAME["viewTable"] = "IconViewTable";
  ICON_NAME["viewTile"] = "IconViewTile";
  ICON_NAME["wallet"] = "IconWallet";
  ICON_NAME["wishlist"] = "IconWishlist";
  ICON_NAME["wishlistAdd"] = "IconWishlistAdd";
  ICON_NAME["wishlistSolid"] = "IconWishlistSolid";
  return ICON_NAME;
}({});
const Icon = props => {
  const {
    className,
    name,
    size = ICON_SIZE.default
  } = props;
  const IconComponent = Icons[name];
  if ((0, _isDefined.isNotDefined)(IconComponent)) {
    throw Error('Unknown icon ' + name);
  }
  const rootClassName = (0, _classnames.default)('cds-Icon', {
    [`cds-Icon--${(0, _upperCase.upperCaseFirst)(size || '')}`]: size !== ICON_SIZE.default,
    [`cds-${name}`]: name
  }, className);
  return /*#__PURE__*/_react.default.createElement(IconComponent, (0, _extends2.default)({}, props, {
    className: rootClassName
  }));
};
exports.Icon = Icon;
//# sourceMappingURL=Icon.js.map